import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {setMenuPresentation} from '../../../redux/actions/menuActions';
import {MenuPresentationTypes} from '../../../constants/menuPresentationTypes';

import './viewSelector.scss';

const ViewSelector = ({t, menuPresentation, setMenuPresentation}) => {

  return (
    <div className={ 'view-selector' }>
        {
            menuPresentation !== MenuPresentationTypes.Thumb && (
                <div
                    className={ `view-type ${menuPresentation === MenuPresentationTypes.Thumb ? 'active' : ''}` }
                    data-mode="shop-thumb"
                    onClick={ () => {
                        setMenuPresentation(MenuPresentationTypes.Thumb);
                    } }
                >
                    <FontAwesomeIcon icon="th-large" />
                </div>
            )
        }

        { menuPresentation !== MenuPresentationTypes.List && (
            <div
                className={ `view-type ${menuPresentation === MenuPresentationTypes.List ? 'active' : ''}` }
                data-mode="shop-thumb"
                onClick={ () => {
                    setMenuPresentation(MenuPresentationTypes.List);
                } }
            >
                <FontAwesomeIcon icon="list" />
            </div>
        )}

    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    menuPresentation
  } = state;

  return {
    menuPresentation
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setMenuPresentation
    },
    dispatch,
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ViewSelector));
